/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ScopeLevel {
  set = 'set',
  subject = 'subject',
  name = 'name',
  row = 'row',
}
